export var CUSTOMIZE_COLUMNS = "Customize columns";
export var DISPLAY_DENSITY = "Display Density";
export var EXPORT = "Export";
export var SEARCH = "Search";
export var SETTINGS = "Settings";
export var MAXIMUM_SIZE_EXCEEDS = function (size) { return "Please upload file less than ".concat(size, " MB in size"); };
export var UNSUPPORTED_TYPE = function (extensions) { return "Please upload supported files types only(".concat(extensions.join(","), ")"); };
export var MAXIMUM_COUNT_EXCEEDS = function (count) { return "Please upload a maximum of ".concat(count, " file(s)"); };
//# sourceMappingURL=labels.js.map